import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createTankApi } from '@/apis/tanks'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { SuccessResponse } from '@/types'
import { CreateTankRequest } from '@/types/apis/tanks/createTankRequest'

export const useCreateTank = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<SuccessResponse>()

  const createTank = useCallback(
    async (request: CreateTankRequest) => {
      try {
        setLoading(true)
        const res = await createTankApi(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        navigate(routes.tanks.path)
      } catch (err) {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createTank,
    response,
  }
}
